import React from "react";
import PropTypes from "prop-types";

/**
 * Base icon component with common SVG structure
 * Reduces duplication across icon components
 * 
 * @param {string} defaultPathColor - Default color for path when pathColor is not provided
 * @param {boolean} forceDefaultPath - If true, always use defaultPathColor regardless of pathColor prop
 */
const IconBase = ({ 
  width = 92, 
  height = 56, 
  strokeColor, 
  fillColor,
  pathColor,
  defaultPathColor = "#8896A4",
  forceDefaultPath = false,
  children,
  ...props 
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 92 56"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <rect
        x={0.75}
        y={0.75}
        width={90.5}
        height={54.5}
        rx={5.25}
        stroke={strokeColor || "#D3D7DA"}
        strokeWidth={1.5}
      />
      <rect 
        x={6} 
        y={6} 
        width={80} 
        height={44} 
        rx={2} 
        fill={fillColor || strokeColor || "#D3D7DA"} 
      />
      <path
        d="M38 31.889v2.333c0 .43.336.778.75.778h10.5c.414 0 .75-.348.75-.778V31.89c0-1.718-1.343-3.111-3-3.111h-6c-1.657 0-3 1.393-3 3.11Zm9-7.778c0 1.718-1.343 3.111-3 3.111s-3-1.393-3-3.11C41 22.391 42.343 21 44 21s3 1.393 3 3.111Z"
        fill={forceDefaultPath ? defaultPathColor : (pathColor ? pathColor : defaultPathColor)}
      />
      {children}
    </svg>
  );
};

IconBase.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string,
  pathColor: PropTypes.string,
  defaultPathColor: PropTypes.string,
  forceDefaultPath: PropTypes.bool,
  children: PropTypes.node,
};

export default IconBase;
